(() => {
  const roots = document.querySelectorAll('[data-fmf-review-lazy]');
  if (!roots.length) return;
  const states = new WeakMap();
  async function activate(root) {
    if (states.get(root)) return states.get(root);
    const widget = root.querySelector('.fmf-deferred-review-widget');
    if (!widget) return;
    const work = (async () => {
      if (typeof window.fmfLoadJudgeMe === 'function') {
        try { await window.fmfLoadJudgeMe(); } catch (e) {}
      }
      widget.id = 'judgeme_product_reviews';
      widget.classList.add('jdgm-widget', 'jdgm-review-widget');
      widget.dataset.widget = widget.dataset.fmfWidget;
      widget.dataset.entryPoint = widget.dataset.fmfEntryPoint;
      widget.dataset.entryKey = widget.dataset.fmfEntryKey;
      const base = window.jdgm?.CDN_BASE_URL;
      if (!base || !widget.dataset.entryPoint) throw new Error('Review loader unavailable');
      const manifestResponse = await fetch(base + 'manifest.json');
      if (!manifestResponse.ok) throw new Error('Review styles unavailable');
      const manifest = await manifestResponse.json();
      const visited = new Set();
      function styles(key) {
        if (visited.has(key)) return;
        visited.add(key);
        const item = manifest[key];
        if (!item) return;
        (item.css || []).forEach(file => {
          const href = base + file;
          if ([...document.querySelectorAll('link[rel="stylesheet"]')].some(link => link.href === href)) return;
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = href;
          document.head.appendChild(link);
        });
        (item.imports || []).forEach(styles);
      }
      styles(widget.dataset.entryKey);
      const source = base + widget.dataset.entryPoint;
      if (![...document.scripts].some(script => script.src === source)) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.type = 'module';
          script.src = source;
          script.onload = resolve;
          script.onerror = () => { script.remove(); reject(new Error('Review module unavailable')); };
          document.head.appendChild(script);
        });
      }
      root.dataset.fmfReviewState = 'ready';
    })().catch(() => {
      states.delete(root);
      root.dataset.fmfReviewState = 'retry';
    });
    states.set(root, work);
    return work;
  }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) activate(entry.target);
      });
    }, { rootMargin: '400px' });
    roots.forEach(root => observer.observe(root));
  } else roots.forEach(activate);
  const badges = document.querySelectorAll('.jdgm-preview-badge, .judgeme-preview-badge');
  badges.forEach(badge => {
    badge.setAttribute('role', 'button');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('aria-label', 'See all reviews');
    badge.addEventListener('keydown', event => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      roots.forEach(activate);
      roots[0].scrollIntoView({ block: 'start' });
    });
  });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-fmf-review-lazy], .jdgm-preview-badge, .judgeme-preview-badge, a[href="#judgeme_product_reviews"]')) roots.forEach(activate);
    if (event.target.closest('.jdgm-preview-badge, .judgeme-preview-badge, a[href="#judgeme_product_reviews"]')) roots[0].scrollIntoView({ block: 'start' });
  }, true);
  function fromHash() {
    if (/#judgeme/.test(location.hash) || /judgeme_(token|review_uuid|dynamic_form|follow_up_token|upload_pictures|pre_verified)/.test(location.search)) {
      roots.forEach(root => { activate(root); root.scrollIntoView({ block: 'start' }); });
    }
  }
  fromHash();
  window.addEventListener('hashchange', fromHash);
})();
